<template>
  <dw-survey-dcs-wrapper :is-temp-save="true" >
    <template v-slot:dw-dcs-main-slot="{survey}" >
      <div class="dw-dcs-main-title">
        <el-row type="flex">
          <el-col :span="18"><div style="font-size: 14px;padding: 10px;"><strong>暂存数据列表</strong></div></el-col>
          <el-col :span="6" style="text-align: right;padding-right: 16px;" ></el-col>
        </el-row>
      </div>
      <div style="padding-top: 20px;padding-left: 20px;">
        <el-form :inline="true" :model="formInline" class="dw-form-inline" size="medium" >
          <div :style="formInlineDivStyle">
            <el-row type="flex" justify="space-between" align="middle" >
              <el-col :span="24">
                <el-form-item label="回答IP" class="formInline-item">
                  <el-input v-model="formInline.ipAddr" placeholder="请输入查询的Ip" clearable></el-input>
                </el-form-item>
                <el-form-item label="地区" class="formInline-item">
                  <el-input v-model="formInline.city" placeholder="请输入查询的地区" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" style="text-align: right">
                <el-form-item style="text-align: right;">
                  <el-button @click="onReset">重置</el-button>
                  <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <el-table
        :data="tableData"
        stripe
        style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="回答IP" >
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p v-html="scope.row.ipAddr" ></p>
              <div slot="reference" class="name-wrapper">
                <div v-html="scope.row.ipAddr"></div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="回答地区" >
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.city }}</span>
          </template>
        </el-table-column>
        <el-table-column label="回答用户" >
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.answerUser != null">
                {{ scope.row.answerUser.name }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="回答的题数" >
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.completeItemNum!=null ? scope.row.completeItemNum:0 }}&nbsp;题</span>
          </template>
        </el-table-column>
        <el-table-column label="回答时间" width="180" >
          <template slot-scope="scope">
            <span>{{ scope.row.endAnDate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="回答终端" width="80" >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.pcm === 1" type="success" >PC端</el-tag>
            <el-tag v-else-if="scope.row.pcm === 2" type="info" >移动端</el-tag>
            <el-tag v-else disable-transitions style="margin-left: 10px" >未知</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="回答用时" width="80" >
          <template slot-scope="scope">
            <span>{{ scope.row.totalTime }}秒</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" >
          <template slot-scope="scope">
            <el-button-group>
              <el-tooltip effect="dark" content="查看数据" placement="top">
                <el-button size="mini" icon="el-icon-view" @click="handleA(`/survey/answer-data.html?id=${scope.row.id}&surveyId=${scope.row.surveyId}`)"></el-button>
              </el-tooltip>
              <el-tooltip effect="dark" content="删除数据" placement="top">
                <el-button size="mini" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></el-button>
              </el-tooltip>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <div class="dw-pagination">
        <el-pagination
          :page-size="pageSize"
          :current-page="currentPage"
          :total="total"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </template>
  </dw-survey-dcs-wrapper>
</template>

<script>

import DwSurveyDcsWrapper from '@/components/common/DwSurveyDcsWrapper'
import {dwSurveyAnswerDelete, dwSurveyAnswerListByParams} from '../../../api/dw-survey'

export default {
  name: 'DwSurveyTempSave',
  components: {
    DwSurveyDcsWrapper
  },
  data () {
    return {
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      formInline: {
        ipAddr: null,
        city: null
      },
      formInlineDivStyle: 'display: flex;'
    }
  },
  mounted () {
    this.queryList(1)
  },
  methods: {
    handleGo (to) {
      this.$router.push(to)
    },
    handleA (to) {
      window.location.href = to
    },
    handlePush: function (to) {
      this.$router.push(to)
    },
    handleDelete (index, row) {
      console.log(index, row)
      this.$msgbox.confirm('确认删除此条答卷吗？', '删除警告', {type: 'warning', confirmButtonText: '确认删除'}).then(() => {
        const data = {id: [row.id]}
        dwSurveyAnswerDelete(data).then((response) => {
          console.log(response)
          const httpResult = response.data
          if (httpResult.resultCode === 200) {
            this.$message.success('删除成功，即将刷新数据。')
            this.queryList(1)
          } else {
            this.$message.error('删除答卷失败')
          }
        })
      }).catch(() => {})
    },
    handleCurrentChange (val) {
      this.queryList(val)
    },
    queryList (pageNo) {
      const {ipAddr, city} = this.formInline
      const params = {pageSize: this.pageSize, current: pageNo, surveyId: this.$route.params.id, isEffective: 0, city, ipAddr, handleState: null, saveStatus: 1}
      dwSurveyAnswerListByParams(params).then((response) => {
        const resultData = response.data.data
        this.tableData = resultData
        this.total = response.data.total
        this.currentPage = response.data.current
        this.pageSize = response.data.pageSize
      })
    },
    onReset () {
      this.formInline = {ipAddr: null, city: null}
      this.queryList(1)
    },
    onSubmit () {
      console.log('submit!')
      this.queryList(1)
    }
  }
}
</script>

<style scoped>
.dw-pagination{
  padding-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/dw-survey/dw-data/DwSurveyTempSave.vue